import { Capacitor } from '@capacitor/core';

// The iOS/Android apps hide every money-related surface (entry fees, payouts /
// prize pools, paid status, Venmo handles) to stay clear of App Store
// guideline 5.3. The website keeps all of it. Hiding is display-only: the data
// stays on the server untouched, and forms never overwrite it on native.
//
// Dev override for testing the native UI in a browser:
//   localStorage.setItem('pnp_force_native_ui', '1')
function forceNativeUi() {
  try {
    return window.localStorage.getItem('pnp_force_native_ui') === '1';
  } catch {
    return false;
  }
}

export const HIDE_MONEY = Capacitor.isNativePlatform() || forceNativeUi();
